import {
  Box,
  Card,
  Typography
} from "@mui/material";
import { useState } from "react";
import { useSelector } from "react-redux";
import Noevent from "../../../../Assets/css/Community/NoEvents.webp";
import FeedIcon from "../../../../Assets/css/Community/FeedIcon.webp";
import SidebarEventCard from "../Events/SidebarEventCard";
import SideBarAllEventCard from "../Events/SideBarAllEventCard";

const CommunityRightSideBar = () => {
  const [activeTab, setActiveTab] = useState(0);

  const registeredAttendees = useSelector(
    (state) => state.community.registeredAttendees
  );
  const events = useSelector((state) => state.community.events);

  const sortedAttendees = Array.isArray(registeredAttendees)
    ? [...registeredAttendees].sort(
      (a, b) => new Date(b.start_time) - new Date(a.start_time)
    )
    : [];



  const showFilteredEvents = sortedAttendees?.length <= 10;
  // console.log("showFilteredEventsNNNN", sortedAttendees)

  const filteredEvents = showFilteredEvents && Array.isArray(events)
    ? events.filter((e) => e.is_my_event === false).slice(0, 10)
    : [];



  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        gap: 3,
      }}
    >
      <Card
        sx={{ flex: 1, minHeight: 500, display: "flex", flexDirection: "column" }}
      >


        {/* Shared scrollable container */}
        <Box sx={{ flex: 1, overflowY: "auto", scrollbarWidth: "none" }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 1,
            }}
          >
            {/* Show content based on conditions */}
            {sortedAttendees?.length === 0 && filteredEvents?.length === 0 ? (
              // Show "No events" when both arrays are empty
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  mt: 2,
                }}
              >
                <img width={"20%"} src={Noevent} alt="No Events" />
                <Typography color="text.secondary" variant="body2" mt={1}>
                  No booked events.
                </Typography>
              </Box>
            ) : (
              <>
                {/* Show Booked Events if available */}
                {sortedAttendees?.length > 0 && (
                  <>
                    <Typography
                      sx={{
                        fontSize: "18px",
                        padding: "10px",
                        fontWeight: "bold",
                        width: "100%",
                        textAlign: "left"
                      }}
                    >
                      Upcoming Events
                    </Typography>
                    {sortedAttendees?.map((event) => (
                      <SidebarEventCard key={event.id} event={event} />
                    ))}
                  </>
                )}

                {/* Show Filtered Events if available */}
                {filteredEvents?.length > 0 && (
                  <>
                    <Typography
                      sx={{
                        fontSize: "18px",
                        padding: "10px",
                        fontWeight: "bold",
                        width: "100%",
                        textAlign: "left"
                      }}
                    >
                      Events for You
                    </Typography>
                    {filteredEvents?.map((event) => (
                      <SideBarAllEventCard key={event?.id} event={event} />
                    ))}
                  </>
                )}
              </>
            )}
          </Box>
        </Box>
      </Card>
    </Box>
  );
};

export default CommunityRightSideBar;
